import React, { CSSProperties, useState, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../Core/hooks';
import { Link } from 'react-router-dom';
import { VscTriangleDown } from "react-icons/vsc";
import { BiSearch } from "react-icons/bi";
import { RxAvatar } from "react-icons/rx";
import { LuKanban } from "react-icons/lu";
import Avatar from "../../Components/Avatar";
//import { getProject } from '../Store/Project';
import { getSettings, heartBeat, setSearchText, setSettingsStatus } from '../../Store/Settings';
import { getRoadmap, saveRoadmapMode, loadRoadmap, setRoadmapStatus } from '../../Store/Roadmap';
import { getProject, saveProjectMode, unloadProject, loadProject,
    setProjects, setProjectStatus, getProjects } from '../../Store/Project';
import { handleLoadComponent } from '../../Helpers/handleLoadComponent';
import { RxDashboard } from 'react-icons/rx';
import { IoPeopleOutline } from 'react-icons/io5';
import { IoMapOutline } from 'react-icons/io5';
import { IoSettingsOutline } from 'react-icons/io5';
import { BsLightning } from "react-icons/bs";
import { IoIosList } from "react-icons/io";
import { IoCalendarOutline } from "react-icons/io5";
import { RoadmapCategory } from '../../Models/RoadmapCategory';
import { getChat, loadChannel } from '../../Store/Chat';
import { getUser, refreshAccessToken, setLastHeartbeat } from '../../Store/Auth';
import { getPlans, getStripe } from '../../Store/Stripe';
import { differenceInDays } from 'date-fns';
//import { BillingContextMenuParam } from '../../Models/Requests/BillingContexMenuParam';
//import BillingContextMenu from '../../Modals/BillingContextMenu';
import { StripePlan } from '../../Models/Requests/StripePlan';
import { StripePayment } from '../../Models/Requests/StripePayment';
import { addDays, parseISO, format } from 'date-fns';
import { IoReturnDownBackOutline } from "react-icons/io5";
import { FaHammer } from "react-icons/fa";
import { AiOutlinePlus } from "react-icons/ai";
import ProjectContextMenu from '../../Modals/ProjectContextMenu';
import RoadmapContextMenu from '../../Modals/RoadmapContextMenu';
import { ProjectContextMenuParams } from '../../Models/Requests/ProjectContextMenuParams';
import { RoadmapContextMenuParams } from '../../Models/Requests/RoadmapContextMenuParams';
import { PopupContextParam } from '../../Models/Requests/PopupContextParam';
import PopupContextMenu from '../../Modals/PopupContext';
import { expandFolder, getFolder, setRoadmapFolders } from '../../Store/Folder';
import { openSocket } from '../../Helpers/openSocket';
import AddChatChannelContextMenu from '../../Modals/AddChatChannelContextMenu';
import { AddChatChannelContextMenuParams } from '../../Models/Requests/AddChatChannelContextMenuParams';

function TopNav() {

    const dispatch = useAppDispatch();
    const userState = useAppSelector(getUser);
    const stripeState = useAppSelector(getStripe);
    const settingsState = useAppSelector(getSettings);
    const roadmapState = useAppSelector(getRoadmap);
    const projectState = useAppSelector(getProject);
    const chatState = useAppSelector(getChat);
    const folderState = useAppSelector(getFolder);
    //const [settingsContextParams, setSettingsContextParams] = useState<SettingsContextParam>();
   // const [billingContextMenuParams, setBillingContextMenuParams] = useState<BillingContextMenuParam>();
    const [search, setSearch] = useState("");
    const [showSubscriptionSuccess, setShowSubscriptionSuccess] = useState(false);
    const [version, setVersion] = useState("");
    const [newVersionExists, setNewVersionExists] = useState(false);
    const [roadmapId, setRoadmapId] = useState<string>("");
    const [projectContextMenuParams, setProjectContextMenuParams] = useState<ProjectContextMenuParams>();
    const [roadmapContextMenuParams, setRoadmapContextMenuParams] = useState<RoadmapContextMenuParams>();
    const [popupParams, setPopupParams] = useState<PopupContextParam>();
    const [addChatChannelContextMenuParams, setAddChatChannelContextMenuParams] = useState<AddChatChannelContextMenuParams>();

    useEffect(() => {
        setVersion(settingsState.version);
        const intervalId = setInterval(() => {
            dispatch(heartBeat());
            //dispatch(getVersion());
        }, 60000);
        return () => clearInterval(intervalId);
    },[]);  
    
    useEffect(() => {
        if (settingsState.version !== "" && settingsState.version !== version) {
            if (version === "") {
                setVersion(settingsState.version);
            } else {
                setNewVersionExists(true);
                //alert("There is a software update available");
            }
        }
    }, [settingsState.version]);

    useEffect(() => {
        if (stripeState.clientSecret !== "") {
            setShowSubscriptionSuccess(true);
            setTimeout(() => setShowSubscriptionSuccess(false), 5000);
        }
    },[stripeState.clientSecret]);

    useEffect(() => {
        if (settingsState.status === "heartbeat") {
            dispatch(setSettingsStatus("idle"));
            dispatch(setLastHeartbeat(format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS")));
        }
    },[settingsState.status]);

    useEffect(() => {
        if (projectState.status === "projectsLoaded" && roadmapId !== "") {
            setProjectStatus("idle");
            dispatch(loadRoadmap(roadmapId));
            setRoadmapId("");
        } else if (projectState.status === "projectLoaded") {
            dispatch(setProjectStatus("idle"));
            handleLoadComponent(dispatch, "work", settingsState.settings);
        }
    }, [projectState.status]);

    useEffect(() => {
        if (roadmapState.status === "roadmapLoaded") {
            dispatch(setRoadmapStatus("idle"));
            reloadRoadmap();
        } else if (roadmapState.status === "roadmapCreated") {
            dispatch(setRoadmapStatus("idle"));
            let roadmaps = [...roadmapState.roadmaps];
            roadmaps.sort(function(a, b) { return b.sort - a.sort });
            /* create uncategorized project */
            if (settingsState.settings.projectCreation === "roadmap" || 
                settingsState.settings.projectCreation === "roadmap_item"
            ) {
                if (roadmaps.length > 0) {
                    let socket = openSocket(dispatch, settingsState);
                    if (socket) {
                        socket.emit("createProject", { 
                            name: "Uncategorized",
                            roadmapId: roadmaps[0]._id,
                            folderId: "",
                            categoryId: ""
                        });
                    }
                }
            }
            reloadRoadmap();
        }
    }, [roadmapState.status]);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.currentTarget.value);
        dispatch(setSearchText(e.currentTarget.value));
    }
/*
    const popSettingsWindow = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        //closeContainer();
        setSettingsContextParams({ _id: "1", event: e }); 
    }
*/

    const reloadRoadmap = () => {
        let loadedProject = projectState.projects.find(p => p.loaded);
        if (loadedProject) {
            dispatch(unloadProject(loadedProject._id));
        }
        handleLoadComponent(dispatch, "roadmap", settingsState.settings);
    }

    const returnToRoadmap = () => {
        reloadRoadmap();
    }
/*
    const handleShowBilling = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        setBillingContextMenuParams({ id: '1', event: e }); 
    }
*/
    const refreshBrowser = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        setVersion(settingsState.version);
        setNewVersionExists(false);
        window.location.reload();
    }

    const handleLoadRoadmap = (e: React.ChangeEvent<HTMLSelectElement> | React.MouseEvent<HTMLSelectElement>) => {
        e.preventDefault();
        let id = e.currentTarget.value;
        //e.stopPropagation();
        /* If we are loading a different roadmap than the one loaded, load
            it and it's projects, else just move on.
            */
        let loadedRoadmap = roadmapState.roadmaps.find(r => r.loaded);
        if (loadedRoadmap && loadedRoadmap._id === id) {
            handleLoadComponent(dispatch, "roadmap", settingsState.settings);
        } else {
            setRoadmapId(id);
            dispatch(getProjects(id));
        }
    }

    const handleLoadProject = (e: React.ChangeEvent<HTMLSelectElement> | React.MouseEvent<HTMLSelectElement>) => {
        e.preventDefault();
        let id = e.currentTarget.value;
        /* If project is already loaded, just switch to project screen, else load the project first */
        let project = projectState.projects.find(p => p.loaded);
        if (project && project._id === id) {
            handleLoadComponent(dispatch, "work", settingsState.settings);
        } else {
            // old.getFolders() dispatch(getFolders());
            dispatch(loadProject(id));
        }
    }

    const handleShowAddRoadmap = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();

        if(userState.earlyAdapter) {
            setRoadmapContextMenuParams({ event: e, _id: "1" });
        } else {
            let limitReached = false;
            let limitMessage = "";
            let ownedRoadmaps = roadmapState.roadmaps.filter(r => r.permission === 'owner');
            let plan = stripeState.plans.find(p => p._id=== stripeState.mostRecentPayment?.stripePlanId);

            if (!plan && ownedRoadmaps.length >= 2) {
                limitReached = true;
                limitMessage = "You can create 2 roadmaps on the free plan. Upgrade to build more.";
            } else if ((plan && plan.name.toLowerCase().includes("starter")) && ownedRoadmaps.length >= 4) {
                limitReached = true;
                limitMessage = "You can create 4 roadmaps on the Starter plan. Upgrade to build more.";
            } else if (plan && plan.name.toLowerCase().includes("essential") && ownedRoadmaps.length >= 10) {
                limitReached = true;
                limitMessage = "You can create 4 roadmaps on the Essentials plan. Upgrade to build more.";
            } else {
                setRoadmapContextMenuParams({ event: e, _id: "1" });   
            }

            if (limitReached) {
                setPopupParams({
                    _id: '1',
                    event: e,
                    buttonClass: "btnDelete",
                    buttonText: "Close",
                    closeHandler: closeLimitPopup,
                    message: limitMessage,
                    headingText: "Limit Reached",
                    backButton: false,
                });
            }
        }
    }

    const handleShowAddProject = (e: React.MouseEvent<HTMLDivElement>, roadmapId: string) => {
        e.preventDefault();
        setProjectContextMenuParams({ event: e, _id: roadmapId });   
    }

    const closeLimitPopup = (e: React.MouseEvent<HTMLDivElement> | React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setPopupParams({
            _id: "",
            event: e,
            buttonClass: "",
            buttonText: "",
            closeHandler: closeLimitPopup,
            message: "",
            headingText: "",
            backButton: false,
        });
    }

    const handleShowAddChat = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        setAddChatChannelContextMenuParams({ event: e, _id: "2" });   
    }
    const handleShowAddChannel = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        setAddChatChannelContextMenuParams({ event: e, _id: "1" });   
    }

    let settings = settingsState.settings;
    let currentMember = undefined;
    //let roadmap: Roadmap | undefined;
    let loadedComponentName = "name of loaded component goes here";
    let componentNav: JSX.Element = (<div></div>);
    let showSearchWork = true;

    let category: RoadmapCategory | undefined = undefined;
    let project = projectState.projects.find(p => p.loaded);
    let recentPayment: StripePayment | null = stripeState.mostRecentPayment;

    let plan: StripePlan | undefined = undefined;
    let roadmap = roadmapState.roadmaps.find(r => r.loaded);

    if (recentPayment) {
        plan = stripeState.plans.find(p => p._id === recentPayment!.stripePlanId);
    }
    
    if (project) {
        category = roadmapState.categories.find(c => c._id === project!.categoryId);
        // let listStyle: CSSProperties = (category) ? { backgroundColor : category.backgroundColor, color: category.fontColor } : {};
    }

    if (settings.loadedComponentType === "global_herdr") {
        showSearchWork = false;
        componentNav = (
            <div style={{ fontSize: "14pt", fontWeight: "550" }}>
                Herdr Platform Settings
            </div>
        );

    } else if (settings.loadedComponentType === "chat") {

        let channel = chatState.channels.find(c => c.loaded);
        if (channel) {
            let name = (channel.name.length <= 60) ? channel.name : channel.name.substring(0,60) + "...";
            componentNav = (
                <div style={{ fontWeight: "bold", fontSize: "12pt" }}>
                    {name}
                </div>
            );
        }

    } else if (settings.loadedComponentType === "roadmap") {
        let roadmap = roadmapState.roadmaps.find(r => r.loaded);
        if (roadmap) {
            loadedComponentName = roadmap.name;

            let dashboardClass = (roadmap.mode === "dashboard") ? "subTopNavSelected" : "subTopNav";
            let generateClass = (roadmap.mode === "generate") ? "subTopNavSelected" : "subTopNav";
            let roadmapClass = (roadmap.mode === "roadmap") ? "subTopNavSelected" : "subTopNav";
            let membersClass = (roadmap.mode === "members") ? "subTopNavSelected" : "subTopNav";
            //let settingsClass = (roadmap.mode === "settings") ? "subTopNavSelected" : "subTopNav";

            if (roadmap._id) {
                componentNav = (
                    <>
                    {roadmap.roadmap && roadmap.permission && 
                        (roadmap.permission.toString() === "owner" || roadmap.permission.toString() === "admin") &&
                        <div className={dashboardClass} style={{ padding: "0px 15px 0px 0px" }} 
                            onClick={() => dispatch(saveRoadmapMode({ _id: roadmap!._id, mode: "dashboard"}))}>
                            <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                                <RxDashboard size={16} />
                            </div>
                            <div className={dashboardClass}>
                                Dashboard
                            </div>
                        </div>
                    }
                    
                    <div className={roadmapClass} style={{ padding: "0px 15px" }} 
                        onClick={() => dispatch(saveRoadmapMode({ _id: roadmap!._id, mode: "roadmap"}))}>  
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <IoMapOutline size={16} />
                        </div>
                        <div className={roadmapClass}>
                            Roadmap
                        </div>
                    </div>
                    {/*
                    <div className={generateClass} style={{ padding: "0px 15px" }} 
                        onClick={() => dispatch(saveRoadmapMode({ id: roadmap!.id, mode: "generate"}))}> 
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <BsLightning size={16} />
                        </div>
                        <div className={generateClass}>
                            Generate
                        </div>
                    </div>
                    */}
                    {roadmap.roadmap && roadmap.permission && 
                        (roadmap.permission.toString() === "owner" || roadmap.permission.toString() === "admin") &&
                        <div className={membersClass} style={{ padding: "0px 15px" }} 
                            onClick={() => dispatch(saveRoadmapMode({ _id: roadmap!._id, mode: "members"}))}>
                            <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                                <IoPeopleOutline size={18} />
                            </div>
                            <div className={membersClass}>
                                Members
                            </div> 
                        </div>
                    }
                    {/*
                    <div className={settingsClass} style={{ padding: "0px 10px" }} 
                       onClick={() => dispatch(saveRoadmapMode({ id: roadmap!.id, mode: "settings"}))}>  
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <IoSettingsOutline size={16} />
                        </div>
                        <div className={settingsClass}>
                            Settings
                        </div> 
                    </div>
                    */}
                    </>
                );
            }
        }
    } else if (settings.loadedComponentType === "work") {

        if (project) {

            let boardClass = (project.mode === "board") ? "subTopNavSelected" : "subTopNav";

            if (project._id) {
                componentNav = (
                    <>
                    <div className="subTopNav" style={{ padding: "0px 15px 0px 0px" }} 
                        onClick={() => returnToRoadmap()}>  
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <IoReturnDownBackOutline size={16} />
                            {/*IoMapOutline */}
                        </div>
                        <div className="subTopNav">
                            Roadmap
                        </div>
                    </div>
                    <div className={boardClass} style={{ padding: "0px 15px 0px 0px" }} 
                        onClick={() => dispatch(saveProjectMode({ _id: project!._id, mode: "board"}))}>  
                        <div style={{ position: "relative", display: "inline-block", top: "-1px", paddingRight: "5px" }}>
                            <LuKanban size={16} />
                        </div>
                        <div className={boardClass}>
                            Board
                        </div>
                    </div>
                    </>
                );
            }
        }
    }

    
    //if (roadmap) {
    
    let searchPlaceholder = "";
    if (settingsState.settings.loadedComponentType === "roadmap") {
        let roadmap = roadmapState.roadmaps.find(r => r.loaded);
        if (roadmap) {
            if (roadmap.mode === "members") {
                searchPlaceholder = "Search members...";
            } else {
                searchPlaceholder = "Search your items...";
            }
        }
    } else if (settingsState.settings.loadedComponentType === "work") {
        searchPlaceholder = "Search your work...";
    } else if (settingsState.settings.loadedComponentType === "chat") {
        searchPlaceholder = "Search your chat...";
    } else {
        searchPlaceholder = "Search your items...";
    }

    let catStyle: CSSProperties = {
        backgroundColor : (category) ? category.backgroundColor : "#efefef",
        color: (category) ? category.fontColor : "#000",
        borderRadius: "30px",
        padding: "4px 10px",
        cursor: "pointer",
        fontSize: "9pt",
        display: "flex", 
        alignItems: "center", 
        position: "relative", 
        top: "1px"
    }

    let roadmaps = [...roadmapState.roadmaps].sort((a, b) =>
        a.name.localeCompare(b.name)
    );

    let projects = [...projectState.projects].sort((a, b) =>
        a.name.localeCompare(b.name)
    );

    let channels = [...chatState.channels].sort((a, b) =>
        a.name.localeCompare(b.name)
    );

    let loadedRoadmap = roadmapState.roadmaps.find(r => r.loaded);
    let loadedProject = projectState.projects.find(p => p.loaded);
    let loadedChannel = chatState.channels.find(c => c.loaded);

    return (
    <>
        {newVersionExists &&
            <div className="updateBannerDiv">
                <FaHammer color="#6B7280" size={20} />
                <span className="updateBannerSpan">
                    We've been hard at work and just released a new version of the app 
                </span>
                <Link to="" onClick={(e) => refreshBrowser(e)} className="updateBannerLink">
                    Take me there!
                </Link>
            </div>
        }

        {settingsState.settings.loadedComponentType !== "global_maps" &&
            settingsState.settings.loadedComponentType !== "chat" &&
            <div style={{ width: "100%", padding: "15px 15px 7px 15px", backgroundColor: "#fff", 
                display: "flex", alignItems: "center",
                justifyContent: "space-between", fontSize: "10pt"
            }}>
                {componentNav}
            </div>
        }

        <div style={{ width: "100%", padding: "0px 15px" }}>

            {showSubscriptionSuccess &&
                <div className="success" style={{ fontSize: "11pt", marginTop: "0px", padding: "5px 20px" }}>
                    You're in - thanks for subscribing!
                </div>
            }
            {showSearchWork &&
                <div style={{ width: "100%", 
                    ...(settingsState.settings.loadedComponentType === "chat"
                    ? { marginBottom: "10px" }
                    : {})
                }}>
                    <div style={{ display: "inline-block", position: "relative", left: "6px", top:"26px" }}>
                        <BiSearch color="gray" size={18} />
                    </div>
                    <div>
                        <input type="text" className="navSearchInput" placeholder={searchPlaceholder} 
                            value={search}
                            onChange={(e) => handleSearchChange(e)}
                        />
                    </div>
                </div>
            }
            {/* Roadmap and project drop downs */}
            {(settingsState.settings.loadedComponentType === "roadmap" || 
                settingsState.settings.loadedComponentType === "global_maps") &&
                <>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }}>
                    <div style={{ width: "90%" }}>
                        <select className="standardInput" 
                        value={loadedRoadmap?._id || "0"}
                        onChange={(e) => handleLoadRoadmap(e)}
                        >
                            <option key="0" value="0">--choose roadmap--</option>
                            {roadmaps.map((r) => (
                                <option key={r._id} value={r._id}>
                                    {r.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div style={{ width: "10%"}} onClick={(e) => handleShowAddRoadmap(e)}>
                        <AiOutlinePlus size={20} style={{ position: "relative", top: "-10px", left: "10px" }} />
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div style={{ width: "90%" }}>
                        <select className="standardInput"
                            value={loadedProject?._id || "0"}
                            onChange={(e) => handleLoadProject(e)}
                            >
                            <option key="0" value="0">--choose project--</option>
                            {projects.map((p) => (
                                <option key={p._id} value={p._id}>
                                    {p.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div style={{ width: "10%"}} onClick={(e) => handleShowAddProject(e, roadmap!._id)}>
                        {roadmap &&
                            <AiOutlinePlus size={20} style={{ position: "relative", top: "-10px", left: "10px" }} />
                        }
                    </div>
                </div>
                </>
            }
            {/* Chat channel and DMs */}
            {settingsState.settings.loadedComponentType === "chat" &&
                <>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }}>
                    <div style={{ width: "100%" }}>
                        <select className="standardInput" 
                            value={loadedChannel?._id || "0"}
                            onChange={(e) => dispatch(loadChannel(e.target.value))}>
                            <option key="0" value="0">--choose a conversation--</option>
                            {channels.map((c) => (
                                <option key={c._id} value={c._id}>
                                    {c.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div style={{ width: "100%", textAlign: "center", marginBottom: "20px" }}>
                    <Link to="" onClick={(e) => handleShowAddChannel(e)}>New Channel</Link>
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    <Link to="" onClick={(e) => handleShowAddChat(e)}>New DM</Link>
                </div>
                </>
            }
        </div>
        <PopupContextMenu params={popupParams} />
        <RoadmapContextMenu params={roadmapContextMenuParams} />
        <ProjectContextMenu params={projectContextMenuParams} />
        <AddChatChannelContextMenu params={addChatChannelContextMenuParams} />
    </>
    );
}

export default TopNav;